<script>
import ViewTitle from '@/components/ViewTitle'
import SvgBackground from '@/components/SvgBackground'
import Button from '@/components/Button'
import EnvironmentUtils from '@/utils/environmentUtils'
import AccountsServices from '@/services/accounts'

export default
{
    name: 'store-notifications-upgrade',

    render () 
    {
        return (
            <div id='store-notifications-upgrade-view'>
                <view-title back-action={true}>Augmenter les capacités de mon compte</view-title>
                <svg-background src={require(`@/assets/img/splash.svg`)}>
                    <inline-svg src={require(`@/assets/img/thunder.svg`)} />
                </svg-background>
                <div class='description'>
                    Cette application offerte par {EnvironmentUtils.clientName} est totalement gratuite et vous profitez des fonctionnalités
                    principales sans limitations gênantes. Cependant en faisant un don (complètement optionnel) de <b>10€/mois</b>, vous nous aidez à supporter ce projet et bénéficiez de quelques avantages supplémentaires en contrepartie.
                </div>
                <Button class='buy-btn' type={this.isDonor ? 'danger' : 'primary'} text={this.isDonor ? 'Ne plus être donateur' : 'Ajouter 10€ à ma cotisation mensuelle'} on-click={this.toggleDonor} />
                <Button text='Non merci' type='text' on-click={() => this.$router.back()} />
                <div class='bulletlist-title'>Contrepartie donateur :</div>
                <div class='bulletlist-item'>✔ Notifications illimitées pour les utilisateurs qui aiment votre page commerce</div>
                <div class='bulletlist-item'>✔ 20 photos supplémentaires dans votre page commerce</div>
            </div>
        ) 
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    computed:
    {
        isDonor ()
        {
            return this.$store.state.user.meta.isDonor
        }
    },

    methods:
    {
        toggleDonor (e, button)
        {
            button.showSpinnerWhile(async () =>
            {
                const updated = await AccountsServices.updateAccount(this.$store.state.user.token, {meta: {isDonor: !this.isDonor}})
                await this.$store.commit('user/setContext', updated)
            })
        }
    },

    components:
    {
        ViewTitle,
        SvgBackground,
        Button
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#store-notifications-upgrade-view
{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 20px;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);

    .OnTablet({
        margin-left: auto;
        margin-right: auto;
        max-width: 550px;
    });
    .OnDesktop({
        margin-top: 8vh;
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
    });

    .svg-background
    {
        width: 250px;
    }

    .description
    {
        margin-top: 40px;
    }

    .button
    {
        margin-top: 10px;
        width: -webkit-fill-available;

        &[type='text']
        {
            & .button-text
            {
                color: var(--theme-text-color);
            }
        }

        &.buy-btn
        {
            margin-top: 30px;
        }
    }

    .bulletlist-title
    {
        margin-top: 30px;
        margin-right: auto;
        font-weight: 600;
        font-size: 20px;
        color: var(--theme-text-color-light);
    }

    .bulletlist-item
    {
        margin-right: auto;
        font-weight: 500;
        color: var(--theme-text-color-light);
        margin-left: 10px;
        margin-top: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/StoreNotificationsUpgrade.vue